"use client"
import { useState } from "react"

export default function SatisfactionWidget({ listingId }: { listingId: string }) {
  const [rating, setRating] = useState<boolean | null>(null)
  const [comment, setComment] = useState("")
  const [submitted, setSubmitted] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  async function submit() {
    if (rating === null) return
    setSubmitting(true)
    try {
      await fetch("/api/feedback", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ listingId, rating, comment: comment.trim() || undefined, page: "listing" }),
      })
      setSubmitted(true)
    } catch {}
    setSubmitting(false)
  }

  if (submitted) return (
    <div style={{ border: "1px solid var(--line)", borderRadius: 12, padding: "16px 20px", marginBottom: 32, background: "var(--cream-warm)", fontSize: 14, color: "var(--green-text)", fontWeight: 600 }}>
      Thank you for your feedback.
    </div>
  )

  return (
    <div style={{ border: "1px solid var(--line)", borderRadius: 12, padding: "16px 20px", marginBottom: 32, background: "var(--cream-warm)" }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: "var(--navy)", marginBottom: 12 }}>Was this listing page helpful?</div>
      <div style={{ display: "flex", gap: 8, marginBottom: rating !== null ? 14 : 0 }}>
        <button
          onClick={() => setRating(true)}
          style={{ padding: "8px 20px", borderRadius: 8, border: "1px solid " + (rating === true ? "var(--green)" : "var(--line)"), background: rating === true ? "rgba(61,139,95,0.1)" : "var(--cream)", color: rating === true ? "var(--green)" : "var(--ink)", fontWeight: 600, fontSize: 13, cursor: "pointer", fontFamily: "inherit", transition: "all 0.15s" }}
        >Yes</button>
        <button
          onClick={() => setRating(false)}
          style={{ padding: "8px 20px", borderRadius: 8, border: "1px solid " + (rating === false ? "var(--red)" : "var(--line)"), background: rating === false ? "rgba(220,53,69,0.07)" : "var(--cream)", color: rating === false ? "var(--red)" : "var(--ink)", fontWeight: 600, fontSize: 13, cursor: "pointer", fontFamily: "inherit", transition: "all 0.15s" }}
        >No</button>
      </div>
      {rating !== null && (
        <>
          <textarea
            value={comment}
            onChange={e => setComment(e.target.value)}
            placeholder="Any comments? (optional)"
            rows={3}
            style={{ width: "100%", padding: "10px 12px", border: "1px solid var(--line)", borderRadius: 8, fontSize: 13, fontFamily: "inherit", background: "var(--cream)", resize: "vertical", outline: "none", boxSizing: "border-box", display: "block" }}
          />
          <button
            disabled={submitting}
            onClick={submit}
            style={{ marginTop: 10, padding: "9px 22px", background: submitting ? "var(--muted)" : "var(--navy)", color: "var(--cream)", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: submitting ? "not-allowed" : "pointer", fontFamily: "inherit" }}
          >{submitting ? "..." : "Submit"}</button>
        </>
      )}
    </div>
  )
}
